export type RuntimeConfig =
  | { readonly apiUrl: string; readonly userPoolId: string; readonly userPoolClientId: string }
  /** Local development only (served by vite dev): no Cognito, the API trusts x-dev-user. */
  | { readonly apiUrl: string; readonly devUser: string };

/** Written at deploy time next to index.html, so one build serves every environment. */
export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('Could not load configuration');
  return (await res.json()) as RuntimeConfig;
}
